import { jsx } from "react/jsx-runtime";
const IconBaseElement = ({
  prefix = "",
  className,
  viewBox = "0 0 24 24",
  ariaHidden = true,
  children,
  ...other
}) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      viewBox,
      focusable: "false",
      width: "24",
      height: "24",
      ...other,
      "aria-hidden": ariaHidden,
      className: `${prefix}svg-icon${className ? ` ${className}` : ""}`,
      children
    }
  );
};
export {
  IconBaseElement
};
